import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"

import {
  getAccessoryUseRequestList,
  getAccessoryUseRequestById,
  createAccessoryUseRequest,
  updateAccessoryUseRequest,
  deleteAccessoryUseRequest,
} from "api/accessoryUseRequestsApi"

export const ACCESSORY_USE_REQUEST_QUERY_KEY = "accessory-use-requests"

// -------------------- FETCH PAGINATED --------------------
export const useAccessoryUseRequests = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCESSORY_USE_REQUEST_QUERY_KEY,
    getAccessoryUseRequestList,
    params,
    enabled
  )
}

// -------------------- FETCH SINGLE ITEM --------------------
export const useAccessoryUseRequest = (id, enabled = true) => {
  return useResourceItem(
    ACCESSORY_USE_REQUEST_QUERY_KEY,
    getAccessoryUseRequestById,
    id,
    enabled
  )
}

// -------------------- CREATE --------------------
export const useCreateAccessoryUseRequest = () => {
  return useCreateResource(
    createAccessoryUseRequest,
    ACCESSORY_USE_REQUEST_QUERY_KEY
  )
}

// -------------------- EDIT --------------------
export const useEditAccessoryUseRequest = () => {
  return useEditResource(
    updateAccessoryUseRequest,
    ACCESSORY_USE_REQUEST_QUERY_KEY
  )
}

// -------------------- DELETE (Soft Delete) --------------------
export const useDeleteAccessoryUseRequest = () => {
  return useDeleteResource(
    deleteAccessoryUseRequest,
    ACCESSORY_USE_REQUEST_QUERY_KEY
  )
}
